module.exports = __webpack_public_path__ + "img/G3.e3f76a49.png";